export const categoryData = [
    {key: 'drinks', text: 'Drinks', value: 'drinks'},
    {key: 'culture', text: 'Culture', value: 'culture'},
    {key: 'film', text: 'Film', value: 'film'},
    {key: 'food', text: 'Food', value: 'food'},
    {key: 'music', text: 'Music', value: 'music'},
    {key: 'travel', text: 'Travel', value: 'travel'},
    {key: 'education', text: 'Education', value: 'education'},
];

export const options = [
    {key: 'Offline', text: 'Offline', value: 'Offline'},
    {key: 'Online', text: 'Online', value: 'Online'},
    
];